module.exports = __webpack_public_path__ + "img/twitter.ec761e91.svg";